import { CLIENT_GET_PAGINATION_STATE } from "@/graphql/operations/client.queries";
import { useQuery } from "@apollo/client";

export function usePaginationState(paginationField: string) {
  const { data } = useQuery(CLIENT_GET_PAGINATION_STATE, { fetchPolicy: "cache-only" });

  return paginationField ? data?.paginationState[paginationField]: data?.paginationState;
}
